import React from "react";
import { createRoot } from "react-dom/client";
import { ReactApp } from "./reactapp";

const root = createRoot(document.getElementById("root")!);
root.render(<ReactApp />);
